// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.modal_modal-overlay_n1MI0 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 510;
    background-color: var(--ui-modal-overlay);
    color: var(--ui-modal-foreground);
    margin-top: var(--stage-fullscreen-top, 0px);
}

.modal_modal-content_ButwH * {
    box-sizing: border-box;
}

/* .modal-content {
    background-color: \$ui-secondary;
} */

.modal_modal-content_ButwH {
    margin: 100px auto;
    outline: none;
    border: 4px solid var(--ui-white-transparent);
    padding: 0;
    border-radius: 0.5rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    overflow: hidden;
}

.modal_modal-content_ButwH.modal_full-screen_tZwxG {
    position: absolute;

    display: flex;
    height: 100%;
    width: 100%;

    overflow-y: auto;
    -webkit-overflow-scrolling: 'touch';
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

    background-color: var(--ui-secondary);

    /* Default modal resets */
    margin: 0;
    border: none;
    border-radius: 0;
}

/*
    Modal header has 3 items:
    |filter     title       x|

    Use the same width for both side item containers,
    so that title remains centered
*/

.modal_header_cCaoO {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    height: 3.125rem;

    box-sizing: border-box;
    width: 100%;
    background-color: var(--ui-modal-header-background);
    color: var(--ui-modal-header-foreground);

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1rem;
    font-weight: normal;
}

.modal_header-item_NHiKj {
    display: flex;
    align-items: center;
    padding: 1rem;
    text-decoration: none;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

[dir="ltr"] .modal_header-image_Bah_r {
    margin-right: 0.5rem;
}

[dir="rtl"] .modal_header-image_Bah_r {
    margin-left: 0.5rem;
}

.modal_header-item-filter_NNfh4 {
    display: flex;
    flex-basis: 20rem;
    justify-content: flex-start;
}

.modal_header-item-title_mB3Md {
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: center;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    letter-spacing: 0.4px;
    cursor: default;
}

[dir="ltr"] .modal_header-item-title_mB3Md {
    margin: 0 -20rem 0 0;
}

[dir="rtl"] .modal_header-item-title_mB3Md {
    margin: 0 0 0 -20rem;
}

.modal_full-screen_tZwxG [dir="ltr"] .modal_header-item-title_mB3Md {
    margin: 0 0 0 -20rem;
}

.modal_full-screen_tZwxG [dir="rtl"] .modal_header-item-title_mB3Md {
    margin: 0 -20rem 0 0;
}

.modal_header-item-close_XEfNI {
    flex-basis: 20rem;
    justify-content: flex-end;
    z-index: 1;
}

.modal_full-screen_tZwxG .modal_header-item-close_XEfNI {
    order: -1;
    justify-content: flex-start;
}

.modal_back-button_t6o8T {
    filter: var(--icon-style);
    font-weight: normal;
    padding-right: 0;
    padding-left: 0;
    -webkit-filter: var(--icon-style);
}

[dir="rtl"] .modal_back-button_t6o8T img {
    transform: scaleX(-1);
}

.modal_header-item-help_r6R8g {
    padding: 0;
    z-index: 1;
    -webkit-filter:;
}

[dir="ltr"] .modal_header-item-help_r6R8g {
    margin-right: -4.75rem;
}

[dir="rtl"] .modal_header-item-help_r6R8g {
    margin-left: -4.75rem;
}

.modal_help-button_ECodz {
    filter: var(--icon-style);
    font-weight: normal;
    font-size: 0.75rem;
}

[dir="ltr"] .modal_help-button_ECodz {
    padding-right: 0;
}

[dir="rtl"] .modal_help-button_ECodz {
    padding-left: 0;
}

.file-selection-modal {
    width: 320px !important;
    max-width: 320px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,yCAAyC;IACzC,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,aAAa;IACb,6CAA6C;IAC7C,UAAU;IACV,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;;IAEzB,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,YAAY;IACZ,WAAW;;IAEX,gBAAgB;IAChB,mCAAmC;IACnC,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;;IAEzB,qCAAqC;;IAErC,yBAAyB;IACzB,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;;;;CAMC;;AAED;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;;IAEhB,sBAAsB;IACtB,WAAW;IACX,mDAAmD;IACnD,wCAAwC;;IAExC,2DAA2D;IAC3D,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 510;\n    background-color: var(--ui-modal-overlay);\n    color: var(--ui-modal-foreground);\n    margin-top: var(--stage-fullscreen-top, 0px);\n}\n\n.modal-content * {\n    box-sizing: border-box;\n}\n\n/* .modal-content {\n    background-color: $ui-secondary;\n} */\n\n.modal-content {\n    margin: 100px auto;\n    outline: none;\n    border: 4px solid var(--ui-white-transparent);\n    padding: 0;\n    border-radius: 0.5rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    overflow: hidden;\n}\n\n.modal-content.full-screen {\n    position: absolute;\n\n    display: flex;\n    height: 100%;\n    width: 100%;\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: 'touch';\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n\n    background-color: var(--ui-secondary);\n\n    /* Default modal resets */\n    margin: 0;\n    border: none;\n    border-radius: 0;\n}\n\n/*\n    Modal header has 3 items:\n    |filter     title       x|\n\n    Use the same width for both side item containers,\n    so that title remains centered\n*/\n\n.header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    height: 3.125rem;\n\n    box-sizing: border-box;\n    width: 100%;\n    background-color: var(--ui-modal-header-background);\n    color: var(--ui-modal-header-foreground);\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 1rem;\n    font-weight: normal;\n}\n\n.header-item {\n    display: flex;\n    align-items: center;\n    padding: 1rem;\n    text-decoration: none;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n[dir=\"ltr\"] .header-image {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .header-image {\n    margin-left: 0.5rem;\n}\n\n.header-item-filter {\n    display: flex;\n    flex-basis: 20rem;\n    justify-content: flex-start;\n}\n\n.header-item-title {\n    flex-grow: 1;\n    flex-shrink: 0;\n    justify-content: center;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    letter-spacing: 0.4px;\n    cursor: default;\n}\n\n[dir=\"ltr\"] .header-item-title {\n    margin: 0 -20rem 0 0;\n}\n\n[dir=\"rtl\"] .header-item-title {\n    margin: 0 0 0 -20rem;\n}\n\n.full-screen [dir=\"ltr\"] .header-item-title {\n    margin: 0 0 0 -20rem;\n}\n\n.full-screen [dir=\"rtl\"] .header-item-title {\n    margin: 0 -20rem 0 0;\n}\n\n.header-item-close {\n    flex-basis: 20rem;\n    justify-content: flex-end;\n    z-index: 1;\n}\n\n.full-screen .header-item-close {\n    order: -1;\n    justify-content: flex-start;\n}\n\n.back-button {\n    filter: var(--icon-style);\n    font-weight: normal;\n    padding-right: 0;\n    padding-left: 0;\n    -webkit-filter: var(--icon-style);\n}\n\n[dir=\"rtl\"] .back-button img {\n    transform: scaleX(-1);\n}\n\n.header-item-help {\n    padding: 0;\n    z-index: 1;\n    -webkit-filter:;\n}\n\n[dir=\"ltr\"] .header-item-help {\n    margin-right: -4.75rem;\n}\n\n[dir=\"rtl\"] .header-item-help {\n    margin-left: -4.75rem;\n}\n\n.help-button {\n    filter: var(--icon-style);\n    font-weight: normal;\n    font-size: 0.75rem;\n}\n\n[dir=\"ltr\"] .help-button {\n    padding-right: 0;\n}\n\n[dir=\"rtl\"] .help-button {\n    padding-left: 0;\n}\n\n:global(.file-selection-modal) {\n    width: 320px !important;\n    max-width: 320px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-overlay": `modal_modal-overlay_n1MI0`,
	"modalOverlay": `modal_modal-overlay_n1MI0`,
	"modal-content": `modal_modal-content_ButwH`,
	"modalContent": `modal_modal-content_ButwH`,
	"full-screen": `modal_full-screen_tZwxG`,
	"fullScreen": `modal_full-screen_tZwxG`,
	"header": `modal_header_cCaoO`,
	"header-item": `modal_header-item_NHiKj`,
	"headerItem": `modal_header-item_NHiKj`,
	"header-image": `modal_header-image_Bah_r`,
	"headerImage": `modal_header-image_Bah_r`,
	"header-item-filter": `modal_header-item-filter_NNfh4`,
	"headerItemFilter": `modal_header-item-filter_NNfh4`,
	"header-item-title": `modal_header-item-title_mB3Md`,
	"headerItemTitle": `modal_header-item-title_mB3Md`,
	"header-item-close": `modal_header-item-close_XEfNI`,
	"headerItemClose": `modal_header-item-close_XEfNI`,
	"back-button": `modal_back-button_t6o8T`,
	"backButton": `modal_back-button_t6o8T`,
	"header-item-help": `modal_header-item-help_r6R8g`,
	"headerItemHelp": `modal_header-item-help_r6R8g`,
	"help-button": `modal_help-button_ECodz`,
	"helpButton": `modal_help-button_ECodz`
};
export default ___CSS_LOADER_EXPORT___;
